import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M16 3c7.278 0 13.342 5.576 13.951 12.826a2.003 2.003 0 0 1-1.807 2.165l-.186.009H17L17 25a2 2 0 0 0 3.994.15L21 25a1 1 0 1 1 2 0 4 4 0 0 1-7.995.2L15 25v-7H4.04a2 2 0 0 1-1.341-.52l-.132-.13a2 2 0 0 1-.519-1.523C2.658 8.577 8.722 3 16 3m-2.475 2.255-.165.037a12.005 12.005 0 0 0-9.289 10.402l-.029.305h5.978c.146-3.682 1.103-6.805 2.618-9.381.297-.505.596-.96.887-1.363M16 5.393l-.041.045c-.464.51-.93 1.12-1.376 1.83l-.221.364c-1.341 2.28-2.197 5.057-2.34 8.367h7.957c-.144-3.31-1-6.087-2.34-8.367-.439-.744-.902-1.387-1.366-1.93zm2.476-.137.135.191q.373.53.751 1.171c1.515 2.576 2.472 5.7 2.618 9.382h5.978l-.029-.3a12.005 12.005 0 0 0-9.453-10.444"
    />
  </svg>
);
const SvgIconRiskInsurance = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconRiskInsurance);
export default Memo;
